// Copyright (c) 2016 Deere & Company

import {updateCreateIncentiveClaimModalVisibility, updateIncentiveClaimModalMode} from './create-incentive-claim-modal-visibility';
import actions from '../../action-list';
import {createIncentiveClaim} from './validate-claim';
import {getUpdatedIncentiveClaim} from '../services/update-incentive-claim';
import {isActionResetFormValidation} from '../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedIncentiveClaim(getState().claims.incentive.claim, selectedAction);

        const updateModalVisibility = () => {

            updateIncentiveClaimModalMode('CREATE')(dispatch);
            updateCreateIncentiveClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_INCENTIVE_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_INCENTIVE
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_INCENTIVE_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createIncentiveClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/update-selected-action.js